
import { Component, Vue } from "vue-property-decorator";
import { talkToUnsplash } from "@/lib/ai/api";

import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import ButtonBarInput from "@/components/Reusable/CustomInputs/ButtonBarInput/ButtonBarInput.vue";
import IconButton from "@/components/UI/IconButton.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import { getImagesToComplete, updateImages } from "@/lib/ai/ai";
import { uiStore } from "@/store/store";
import NotificationLogger from "@/lib/notifications/notifications";
import { UnsplashImage } from "@/lib/ai/types";

@Component({
  components: {
    TextInput,
    NumberInput,
    IconButton,
    NiceButton,
    ButtonBarInput,
    TopBarSection
  }
})
export default class AIUnsplash extends Vue {
  images: UnsplashImage[] = [];
  loading = false;
  fillEmptyImagesOnly = false;
  keywords = "";
  orientation: "landscape" | "portrait" | "squarish" | null = null;

  get imagesFields() {
    if (!uiStore.activeElement) return [];
    return getImagesToComplete(uiStore.activeElement);
  }

  async fetchImages() {
    if (!this.keywords) {
      NotificationLogger.log.errorMessage(
        "Please enter a keyword to fetch images."
      );
      return;
    }

    if (this.imagesFields.length === 0) {
      NotificationLogger.log.errorMessage(
        "No images to complete. Please add an image to the section first."
      );
      return;
    }

    this.loading = true;
    await this.talkToUnsplash();

    if (!this.images.length) {
      NotificationLogger.log.errorMessage(
        "No images found. Please try again with different keywords."
      );
      this.loading = false;
      return;
    }

    updateImages(this.imagesFields, this.images, this.fillEmptyImagesOnly);

    this.loading = false;
    this.keywords = "";
    this.images = [];
  }

  async talkToUnsplash() {
    this.images = await talkToUnsplash(
      [this.keywords],
      this.imagesFields.length,
      this.orientation
    );
  }
}
